import { type BasicObject } from '@pkg/types';

// TODO: Consider a recursive version of this function.
// https://github.com/beefchimi/socialite/issues/7
export function filterNullishValuesFromObject<T = BasicObject>(obj = {}): T {
    const keys = Object.keys(obj) as (keyof typeof obj)[];

    return keys.reduce<T>((accumulator, current) => {
        return obj[current] == null
            ? accumulator
            : {
                  ...accumulator,
                  [current]: obj[current],
              };
    }, {} as T);
}

// This recursive alternative is loosely typed and can be improved.
export function removeEmptyFromObject(obj) {
    const newObj = {};

    Object.keys(obj).forEach((key) => {
        if (obj[key] === Object(obj[key])) newObj[key] = removeEmptyFromObject(obj[key]);
        else if (obj[key] !== undefined) newObj[key] = obj[key];
    });

    return newObj;
}
